import { render } from "./AddAlarmComment.vue?vue&type=template&id=0483ad22&ts=true"
import script from "./AddAlarmComment.vue?vue&type=script&lang=ts"
export * from "./AddAlarmComment.vue?vue&type=script&lang=ts"

import "./AddAlarmComment.vue?vue&type=style&index=0&id=0483ad22&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__